
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["w-8 h-7 mx-auto",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"stroke-miterlimit":"10","viewBox":"0 0 512 450","xmlns":"http://www.w3.org/2000/svg","clip-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"evenodd","stroke":"#000","stroke-width":"10"}},[_c('path',{attrs:{"d":"M30 20h230l-90 40v200H30V20z"}}),_c('path',{attrs:{"d":"M300 20v40h-90l90-40zM190 310V80h300L320 180l170 130H190z"}})]),_c('path',{attrs:{"d":"M30 20v410","fill":"none","stroke":"#000","stroke-width":"20"}})])
          )
        }
      }
    